import { FullStory, isInitialized } from '@fullstory/browser';

export const FullStoryEvent = {
  TitleMonitoringPropertyNotVerified: 'Title Monitoring Property Not Verified',
  TitleMonitoringPropertyNotEligible: 'Title Monitoring Property Not Eligible',
} as const;

export const TITLE_MONITORING_PROPERTY_NOT_VERIFIED_TITLE = 'Property Not Verified';
export const TITLE_MONITORING_PROPERTY_NOT_ELIGIBLE_TITLE = 'Property Not Eligible for Monitoring';

export function trackFullStoryEvent(name: string, properties: Record<string, string>): void {
  if (!isInitialized()) {
    return;
  }

  try {
    FullStory('trackEvent', { name, properties });
  } catch {
    /* third-party failure must never break the page */
  }
}

export function trackTitleMonitoringSignupFailure(
  errorTitle: string,
  propertyAddress: string,
  agentName?: string,
): void {
  const eventName =
    errorTitle === TITLE_MONITORING_PROPERTY_NOT_VERIFIED_TITLE
      ? FullStoryEvent.TitleMonitoringPropertyNotVerified
      : errorTitle === TITLE_MONITORING_PROPERTY_NOT_ELIGIBLE_TITLE
      ? FullStoryEvent.TitleMonitoringPropertyNotEligible
      : null;

  if (!eventName) {
    return;
  }

  const properties: Record<string, string> = { propertyAddress };
  const firmName = agentName?.trim();

  if (firmName) {
    properties.firmName = firmName;
  }

  trackFullStoryEvent(eventName, properties);
}
